import { ImgHTMLAttributes, PropsWithChildren, CSSProperties } from 'react'

import { sva, cx, cva } from 'styled-system/css'

const imageRecipe = cva({
  base: {
    maxWidth: 'full',
  },
  variants: {
    border: {
      true: {
        borderRadius: 'l3',
        borderWidth: '1',
        borderColor: 'border.muted',
      },
    },
    caption: {
      true: {
        borderRadius: 'l3',
        borderWidth: '1',
        borderColor: 'border.muted',
        backgroundColor: 'bg.default',
        padding: '4',
      },
    },
  },
})
export default function DocImage({
  className,
  alt,
  title,
  border,
  maxWidth,
  style,
  ...props
}: ImgHTMLAttributes<HTMLImageElement> & {
  border?: boolean
  maxWidth?: number
}) {
  const caption = title || alt
  const imgStyle: CSSProperties = style ? style : {}
  if (maxWidth) {
    imgStyle.maxWidth = maxWidth
  }

  const imageClassnames = imageRecipe({
    border,
    caption: !!caption,
  })

  return (
    <ImageWithCaption caption={caption}>
      <img
        className={cx(imageClassnames, className)}
        alt={alt}
        title={title}
        {...props}
        style={imgStyle}
      />
    </ImageWithCaption>
  )
}

const captionRecipe = sva({
  slots: ['root', 'caption'],
  base: {
    root: {
      marginTop: '6',
      marginBottom: '8',
    },
    caption: {
      display: 'inline-block',
      borderTopLeftRadius: 'l3',
      borderTopRightRadius: 'l3',
      borderInlineWidth: '1',
      borderInlineColor: 'border.subtle',
      borderBlockStartWidth: '1',
      borderBlockStartColor: 'border.subtle',
      backgroundColor: 'bg.subtle',
      fontSize: 'sm',
      color: 'fg.muted',
      fontWeight: 'normal',
      marginLeft: '6',
      paddingLeft: '4',
      paddingRight: '4',
      paddingTop: '1',
      paddingBottom: '1',
    },
  },
})
const captionClassnames = captionRecipe()

function ImageWithCaption({
  caption,
  children,
}: PropsWithChildren<{ caption?: string }>) {
  if (caption) {
    return (
      <figure className={captionClassnames.root}>
        <figcaption className={captionClassnames.caption}>{caption}</figcaption>
        {children}
      </figure>
    )
  }

  return <>{children}</>
}
